import moment from "moment";

export const formatRupees = (amount) => {
  if (amount === null || amount === undefined) return "-";

  const num = parseFloat(amount);
  if (isNaN(num)) return "-";

  if (num === 0) return `₹0.00`;
  if (num > 0) return `₹${num.toFixed(2)}`;
  if (num < 0) return `-₹${Math.abs(num).toFixed(2)}`;
};

export const formatAmountSuffix = (value, originalValueWithCurrency = false) => {
  if (originalValueWithCurrency) {
    return formatRupees(value);
  }
  if (value === null || value === undefined || isNaN(Number(value))) return "-";
  const num = Number(value);
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 10000000) return `${sign}₹ ${(abs / 10000000).toFixed(1)}Cr`;
  if (abs >= 100000) return `${sign}₹ ${(abs / 100000).toFixed(1)}L`;
  if (abs >= 1000) return `${sign}₹ ${(abs / 1000).toFixed(1)}K`;
  return `${sign}₹ ${abs}`;
};

export const formatBalance = (balance) => {
  if (balance === null || balance === undefined) return "-";

  const num = parseFloat(balance);
  if (isNaN(num)) return "-";

  if (num === 0) return `₹0.00`;
  if (num > 0) return `-₹${num}`;
  if (num < 0) return `₹${Math.abs(num)}`;
};

/**
 * Formats the balance for expense accounts
 * Used to display the balance of Worker, Employee, Vendor, Subcontractor accounts as positive in the UI, even though they are stored as negative in the backend
 */
export const formatExpenseAccountBalance = (balance) => `₹${-(Number(balance) || 0)}`;

export const getBalanceColor = (balance) => {
  const num = parseFloat(balance);
  if (isNaN(num) || num === 0) return "text.primary";
  return num > 0 ? "success.main" : "error.main";
};

export const getDateAndTime = (datetime) => {
  if (!datetime) return "";
  return moment(datetime).format("MMM D, YYYY h:mm A");
};

export const getAccountName = (accountType, accountDetails) => {
  switch (accountType) {
    case "USER":
      return `${accountDetails?.ownerUser?.firstName} ${accountDetails?.ownerUser?.lastName}`;
    case "CASH":
      return `${accountDetails?.ownerUser?.firstName} ${accountDetails?.ownerUser?.lastName}`;
    case "CLIENT":
      return `${accountDetails?.ownerClient?.name} (${accountType})`;
    case "SUBCONTRACTOR":
    case "VENDOR":
      return `${accountDetails?.ownerVendor?.name} (${accountType})`;
    case "EMPLOYEE":
    case "WORKER":
      return `${accountDetails?.ownerEmployee?.name} (${accountType})`;
    default:
      return accountDetails?.name;
  }
};

export const formatPayload = (details, isEdit = false) => {
  const formatted = { ...details };

  Object.keys(formatted).forEach((key) => {
    const value = formatted[key];

    if (typeof value === "string") {
      const trimmed = value.trim();

      if (trimmed === "") {
        if (isEdit) formatted[key] = null;
        else delete formatted[key];
      } else {
        formatted[key] = trimmed;
      }
    }
  });

  return formatted;
};

export const getAcronym = (str) => {
  if (!str) return "";
  const words = str.trim().split(/\s+/);
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return words
    .slice(0, 3)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
};
